<div  id="containerFoto" class="container">
    <img class="background-foto" src="../../../assets/images/02b_Unesco-Aspromonte_Pietra-Cappa-new.jpg">
<div class="content">
    <h1>Calabria</h1>
    <h3>Siti UNESCO</h3>
</div>
</div>
<br>
<div class="breadcrumb">
    <p><a>Scopri la Calabria</a> > <a class="active">Siti UNESCO</a></p>
</div>
<br>
<div id="fixed-element" [ngClass]="[isFixed ? 'fixed': 'notFixed']">
    <app-sidenav></app-sidenav>
</div>
<div style="text-align: center; margin-top: 30px;">
    <div class="textCenter">
        <p>
            Il libro dei siti patrimonio dell’Umanità dei Parchi calabresi si compone di molte pagine; si tratta di luoghi che regalano esperienze indimenticabili 
            come le Faggete vetuste di Cozzo Ferriero e del Pollinello nel Parco nazionale del Pollino, che vanta ben 75 geositi nella Rete Europea e Globale dei Geoparchi, 
            a cui fanno eco gli otto geositi e la faggeta vetusta di Valle Infernale del Parco nazionale dell’Aspromonte. Senza dimenticare la Riserva della Biosfera “MaB Sila”,
             la decima Riserva della Biosfera italiana nella Rete Mondiale dei siti di eccellenza UNESCO, 
             che riguarda un territorio vastissimo di circa 335 mila ettari che si estende dall’altopiano silano fino al Golfo di Squillace, sullo Jonio.
            <br>
            <br>
            Altri beni patrimonio dell’Umanità in Calabria riguardano la cultura e la storia di questa terra antichissima, e sono: il Duomo di Cosenza, 
            la Cattedrale riconsacrata nel 1222 alla presenza di Federico II che, in quell’occasione, donò la preziosa Stauroteca, il Codex Purpureus Rossanensis, 
            uno dei più antichi evangeliari esistenti al Mondo, la Varia di Palmi, la festa dedicata a Maria Santissima che si celebra da oltre quattro secoli,
            e il Greco di Calabria, fra le lingue più antiche a rischio di estinzione; senza dimentica la Cattolica di Stilo, pero ora presente fra le candidature.            
        </p>
    </div>
</div>
<!-- <br>
<br>
<div class="divider">

</div>
<br>
<br>
<div class="row bannerPollino">
    <div class="col-8">
        <h1 class="banner-header">ESPERIENZE E ITINERARI</h1>
        <br>
        <p>Scegli fra le tante idee di viaggio e proposte di itinerari tematici<br />per conoscere il Parco nazionale dell’Aspromonte.</p>
    </div>
    <div class="col-1">
        <img style="width: 65%;" src="../../../assets/images/logo-parco-top2.png">
    </div>
</div>
<br>
<br>
<div class="home-card">
    <div class="row">
        <div class="col-3 one" id="one">
            <div class="card one">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Sulle strade<br />della Ciclovia<br />dei Parchi</h1>
                        <a (click)="goToCiclovia()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 two" id="two">
            <div class="card two">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Gerace</h1>
                        <a (click)="goToGerace()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3 three" id="three">
            <div class="card three">
                <div class="card-body">
                    <div class="content-card">
                        <h1>Area grecanica</h1>
                        <a (click)="goToAreaGrecanica()">Scopri</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<br>
<br>
<div class="divider">
    
</div> -->
<br>
<br>
<app-mappe-tematiche></app-mappe-tematiche>
<br>
<br>

<div class="noMobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi <br />
                    iscriviti alla nostra newsletter ></h2>
            </div>
            <div class="col">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />
                    novità su proposte, esperienze, eventi e qualche curiosità.</p>  
            </div>
        </div>
        <div class="row">
            <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
        </div>
    </div>
</div>


<div class="mobileNews">
    <div class="newsletter">
        <div class="row">
            <div class="col">
                <h2>Rimani in contatto con noi<br />iscriviti alla nostra newsletter</h2>
            </div>
        </div>
        <br>
        <div class="row">
            <div class="col-sm-12">
                <h3>Entra nella community di Zampino Viaggi!</h3>
                <br>
                <p>Clicca sul pulsante qui sotto, compila il form e riceverai le nostre<br />novità su proposte, esperienze, eventi e qualche curiosità.</p>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <a href="#" class="btn btn-primary signinNewsButton">Scopri</a>
            </div>
        </div>
    </div>
</div>